import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { ICategoryInput } from "@/interfaces/product.category.interfaces";
import categoryService from "@/services/category.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateCategoryProps = UpdateByIdProps<ICategoryInput>;

export type UseUpdateCategoryReturn = {
  update: (props: UpdateCategoryProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateCategory = (): UseUpdateCategoryReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } = useUpdate<ICategoryInput>({
    operation: (formData, categoryId) => categoryService.update(formData, categoryId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    update,
  };
};

export default useUpdateCategory;
